export class SelfTimingEvent {
    Id : string;
    Name : string;
    Organizer : string;
    Classes : EventClass[];
    Date : Date;
    Description : string;
    IsAdmin? : boolean;
    EntryOpen : boolean;
    ShowPublic : boolean;
}

export class EventClass {
    Name : string;
    CourseLength: number;
    Course:CoursePost[];
}
export class CoursePost {
    PostCode : number
}

export type EventEntryList = {Event : string, Class : string, "Entries" : Entry[]}[];

export class Entry {
    Id: string;
    FirstName : string;
    LastName : string;
    Team : string;
    TagNo : number;
}